<template>
    <SideFormSection :showDivider="true">
        <template #title>Edit User</template>
        <template #subtitle>
            Update this user's role and active status.
        </template>
        <template #rawContent>
            <Card
                title="Settings"
                iconName="gears"
            >
                <template #content>
                    <ApiForm
                        :url="
                            urlFactory.makeCompanyUserUpdateUrl(
                                localCompanyUser.id,
                            )
                        "
                        method="POST"
                        ref="apiFormRef"
                    >
                        <CompanyUserForm
                            :companyUser="localCompanyUser"
                            :errors="
                                apiFormRef?.response?.getErrors() ??
                                new ApiFormErrors({})
                            "
                        />
                    </ApiForm>
                </template>
                <template #actions>
                    <Button
                        @click="submit()"
                        :loading="apiFormRef?.loading.valueOf()"
                        iconName="save"
                        color="dark"
                    >
                        Save
                    </Button>
                </template>
            </Card>
        </template>
    </SideFormSection>
</template>

<script setup lang="ts">
    import { ref, type PropType } from 'vue'
    import CompanyUser from '@/App/CompanyUser/Entity/CompanyUser'
    import SideFormSection from '@/Shared/Component/SideFormSection.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import Button from '@/Shared/Component/Button.vue'
    import Card from '@/Shared/Component/Card.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import CompanyUserForm from '@/App/CompanyUser/Component/CompanyUserForm.vue'
    import CompanyUserAggregate from '@/App/CompanyUser/Entity/CompanyUserAggregate'
    import ApiFormResponseType from '@/Shared/Component/Forms/ApiFormResponseType'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import { ResponseJsonKeyEnum } from '@/Shared/AutoGenerated/Main'
    import { UrlFactory } from '@/Shared/Url/UrlFactory'

    const emits = defineEmits<{
        onSuccess: [{ companyUserAggregate: CompanyUserAggregate }]
    }>()

    const props = defineProps({
        companyUser: {
            type: Object as PropType<CompanyUser>,
            required: true,
        },
    })

    const apiFormRef = ref<ApiFormRefType>(null)
    const urlFactory = new UrlFactory()
    const localCompanyUser = ref<CompanyUser>(props.companyUser)

    const submit = () => {
        apiFormRef.value?.submit()?.then((response: ApiFormResponseType) => {
            emits('onSuccess', {
                companyUserAggregate: response.getHydratedCompanyUserAggregate(
                    ResponseJsonKeyEnum.App_CompanyUser_UpdateSettings_CompanyUserAggregateData,
                ),
            })
        })
    }
</script>
